import React, { useState, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useQueryWithSimpleErrorHandling } from 'hooks/apolloWrappers';
import { BALANCE_SHEET_SUMMARY_INFO } from "../queries";
import { BalanceSheetDetailsContainer } from "./BalanceSheetDetailsContainer";
import { BalanceSheetDetailsIndicatorsContainer } from "./BalanceSheetDetailsIndicatorsContainer";
import { AppBar, Tabs, Tab } from "@mui/material";
import PropTypes from "prop-types";

import { importPartnerBalanceSheet} from "../../../actionCreators";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

export const BalanceSheetDetailsTabsContainer = ({actions}) => {
  const [t] = useTranslation();
  const params = useParams();
  const balanceSheetId = parseInt(params?.balanceSheetId);
  const [value, setValue] = useState("details");
  const [balanceSheetSummaryInfo, setbalanceSheetSummaryInfo] = useState(null);

  useQueryWithSimpleErrorHandling(BALANCE_SHEET_SUMMARY_INFO, {
    variables: { balanceSheetId },
    onCompleted: data => {
      setbalanceSheetSummaryInfo(data?.partnerBalanceSheetSummaryInfo || {});
    }
  });

  const title = useMemo(() => 
    { 
    return `${balanceSheetSummaryInfo?.partnerName ?? ""} - ${t('BalanceSheet.BalanceSheetDetailTitle')} - ${balanceSheetSummaryInfo?.dimensionYear ?? ""}.${balanceSheetSummaryInfo?.dimensionMonth?? ""}` 
    }, [balanceSheetSummaryInfo, t]);  

  const handleChange = useCallback((_, newValue) => {
    setValue(newValue);
  }, [])

  return (
    <>
      <AppBar position="static" color="default" sx={{ my: 1, borderRadius: "1rem", px: 2 }}>
        <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="scrollable">
          <Tab label={t("BalanceSheet.DetailsTitle")} value="details" />
          <Tab label={t("BalanceSheet.Indicators.Title")} value="indicators" />
        </Tabs>
      </AppBar>
      {value === "details" && <BalanceSheetDetailsContainer actions={actions} title ={title} currencyCode={balanceSheetSummaryInfo?.currencyCode ?? ""}/>}
      {value === "indicators" && <BalanceSheetDetailsIndicatorsContainer title ={title} />}
    </>
  );
};

BalanceSheetDetailsTabsContainer.propTypes = {
  actions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        importPartnerBalanceSheet
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(null,mapDispatchToProps)(BalanceSheetDetailsTabsContainer);
 